import { io } from "socket.io-client";

const socket = io("https://socket2.logicalcrm.com", { autoConnect: false });
// const socket = io("http://localhost:3005", { autoConnect: false });
export default socket;